import { Component } from 'react';

import logger from './shims/Logger.js';

// The read-only app otherwise has no crash isolation: a single render-phase throw
// — e.g. a malformed zone the darwin_core reducer stored as `{}` (unknown zone
// type / missing zoneId), or an unguarded selector on sparse state — would blank
// the entire page with no recovery. This boundary catches any such throw and
// offers a reload instead. Error boundaries must be class components; there is no
// hook equivalent.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Diagnostics only. A render-phase error here carries no token material; log
    // the message + component stack, never a raw object that could hold more.
    logger.error(
      'Unhandled render error',
      error?.message,
      info?.componentStack,
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-shell">
          <h1>Halo</h1>
          <p className="session-gate__message" role="alert">
            Something went wrong displaying this page.
          </p>
          <div className="session-gate__actions">
            <button type="button" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
